import React, { Component } from 'react';
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  Radio,
  Checkbox,
} from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from './Contents/Consideration';
import Select from '../Select';

export default class Consideration extends Component {
  options = () => ({
    payable: this.props.payable,
    royalty: this.props.royalty,
    gratis: this.props.gratis,
    flatFee: this.props.flatFee || 0,
    schedule: this.props.schedule,
    fee: this.props.fee,
    percent: this.props.percent,
    describe: this.props.describe,
    period: this.props.period,
    audit: this.props.audit,
    scheduleDays0: this.props.scheduleDays0,
    scheduleDays1: this.props.scheduleDays1,
    scheduleAmount: this.props.scheduleAmount,
    scheduleAmountDays: this.props.scheduleAmountDays,
    scheduleBalance: this.props.scheduleBalance,
    scheduleBalanceDays: this.props.scheduleBalanceDays,
  });

  handleContent(key, value) {
    const options = this.options();

    options[key] = value;

    switch (key) {
      case 'fee':
        options.payable = true;
        break;
      case 'percent':
      case 'describe':
      case 'period':
      case 'audit':
        options.royalty = true;
        break;
      case 'scheduleDays0':
        options.schedule = 0;
        break;
      case 'scheduleDays1':
        options.schedule = 1;
        break;
      case 'scheduleAmount':
      case 'scheduleAmountDays':
      case 'scheduleBalance':
      case 'scheduleBalanceDays':
        options.schedule = 2;
        break;

      default:
        break;
    }

    if (options.payable === true || options.royalty === true) {
      options.gratis = false;
    }

    if (key === 'gratis' && value === true) {
      options.gratis = true;
      options.payable = false;
      options.royalty = false;
    }

    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          <Col sm={12}>
            <p className="question">
              How will the Contributor be compensated for their contribution?
            </p>
            <FormGroup className="answer">
              <Checkbox
                name="payable"
                checked={this.props.payable === true}
                onClick={(e) => this.handleContent('payable', e.target.checked)}
              >
                The Contributor will be paid a flat fee of $&nbsp;
                <FormControl
                  type="number"
                  className="input-sm"
                  placeholder="$"
                  value={this.props.fee}
                  onChange={(e) => this.handleContent('fee', e.target.value)}
                />
                &nbsp;or an advance on royalties, if also receiving a royalty.
              </Checkbox>
              <Checkbox
                name="royalty"
                checked={this.props.royalty === true}
                onChange={(e) =>
                  this.handleContent('royalty', e.target.checked)
                }
              >
                The Contributor will receive a royalty.
              </Checkbox>
              {this.props.royalty === true ? (
                <ul>
                  <li>
                    <div className="pb1">
                      The Contributor will be paid a royalty of&nbsp;
                      <FormControl
                        type="number"
                        className="input-sm"
                        placeholder="percentage"
                        value={this.props.percent}
                        onChange={(e) =>
                          this.handleContent('percent', e.target.value)
                        }
                      />
                      &nbsp;% of&nbsp;
                      <FormControl
                        type="text"
                        className="input-lg"
                        placeholder="what type of revenue stream?"
                        value={this.props.describe}
                        onChange={(e) =>
                          this.handleContent('describe', e.target.value)
                        }
                      />
                      .
                    </div>
                  </li>
                  <li>
                    <div className="pb1">
                      The Owner will account to the Contributor and pay
                      royalties
                      <Select
                        className="select-mini"
                        value={this.props.period}
                        onChange={(e) =>
                          this.handleContent('period', e.target.value)
                        }
                      >
                        <option value="">select</option>
                        <option>monthly</option>
                        <option>quarterly</option>
                        <option>semi-annually</option>
                        <option>annually</option>
                      </Select>
                    </div>
                  </li>
                  <li>
                    <div className="pb1">
                      The Contributor
                      <Select
                        className="select-mini"
                        value={this.props.audit}
                        onChange={(e) =>
                          this.handleContent('audit', e.target.value)
                        }
                      >
                        <option value="">select</option>
                        <option>will</option>
                        <option>will not</option>
                      </Select>
                      have a right to audit/examine the Owner’s books and
                      records.
                    </div>
                  </li>
                </ul>
              ) : null}
              <Checkbox
                name="gratis"
                checked={this.props.gratis === true}
                onClick={(e) => this.handleContent('gratis', e.target.checked)}
              >
                The Contributor is not receiving monetary compensation, but
                getting other, promotional or marketing value from their
                contribution.
              </Checkbox>
            </FormGroup>
            {this.props.payable === true ? (
              <div>
                <p className="question">
                  Will the amount paid to the Contributor be a flat fee or an
                  advance that can be recouped with royalties?
                </p>
                <FormGroup className="answer">
                  <Radio
                    name="flatFee"
                    checked={this.props.flatFee === 0}
                    readOnly
                    onClick={(e) => this.handleContent('flatFee', 0)}
                  >
                    A flat fee.
                  </Radio>
                  <Radio
                    name="flatFee"
                    checked={this.props.flatFee === 1}
                    readOnly
                    onClick={(e) => this.handleContent('flatFee', 1)}
                  >
                    An advance.
                  </Radio>
                </FormGroup>
                <p className="question">When will the Contributor be paid?</p>
                <FormGroup className="answer">
                  <Radio
                    name="schedule"
                    checked={this.props.schedule === 0}
                    readOnly
                    onClick={(e) => this.handleContent('schedule', 0)}
                  >
                    In full, within&nbsp;
                    <FormControl
                      type="number"
                      className="input-sm"
                      placeholder="DAYS"
                      value={this.props.scheduleDays0}
                      onChange={(e) =>
                        this.handleContent('scheduleDays0', e.target.value)
                      }
                    />
                    &nbsp;days following full execution of this agreement.
                  </Radio>
                  <Radio
                    name="schedule"
                    checked={this.props.schedule === 1}
                    readOnly
                    onClick={(e) => this.handleContent('schedule', 1)}
                  >
                    In full, within&nbsp;
                    <FormControl
                      type="number"
                      className="input-sm"
                      placeholder="DAYS"
                      value={this.props.scheduleDays1}
                      onChange={(e) =>
                        this.handleContent('scheduleDays1', e.target.value)
                      }
                    />
                    &nbsp;days following the completion and delivery of the
                    services.
                  </Radio>
                  <Radio
                    name="schedule"
                    checked={this.props.schedule === 2}
                    readOnly
                    onClick={(e) => this.handleContent('schedule', 2)}
                  >
                    $&nbsp;
                    <FormControl
                      type="number"
                      className="input-sm"
                      placeholder="AMOUNT"
                      value={this.props.scheduleAmount}
                      onChange={(e) =>
                        this.handleContent('scheduleAmount', e.target.value)
                      }
                    />
                    &nbsp;payable within&nbsp;
                    <FormControl
                      type="number"
                      className="input-sm"
                      placeholder="DAYS"
                      value={this.props.scheduleAmountDays}
                      onChange={(e) =>
                        this.handleContent('scheduleAmountDays', e.target.value)
                      }
                    />
                    &nbsp;days following full execution of this agreement, and
                    the balance $&nbsp;
                    <FormControl
                      type="number"
                      className="input-sm"
                      placeholder="BALANCE"
                      value={this.props.scheduleBalance}
                      onChange={(e) =>
                        this.handleContent('scheduleBalance', e.target.value)
                      }
                    />
                    &nbsp;payable within&nbsp;
                    <FormControl
                      type="number"
                      className="input-sm"
                      placeholder="DAYS"
                      value={this.props.scheduleBalanceDays}
                      onChange={(e) =>
                        this.handleContent(
                          'scheduleBalanceDays',
                          e.target.value
                        )
                      }
                    />
                    &nbsp;days following the completion and delivery of the
                    services.
                  </Radio>
                </FormGroup>
              </div>
            ) : null}
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  "Consideration" is the payment of something of value to the
                  independent contractor in exchange for the work they have
                  done. This section defines what the consideration is and the
                  payment schedule.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is an "advance"?</p>
                <p className="small">
                  An "advance" is an upfront payment of money that is offset in
                  the future by royalties or other types of income.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What does "recoup" mean?</p>
                <p className="small">
                  "Recoup" is short for "recuperation" and means to be
                  compensated for something that has been paid out, such as an
                  advance.
                </p>
              </div>
              {/* <p className="small">
                                    <strong>Text Box A</strong>: Enter a percentage (numerical value)
                                </p>
                                <p className="small">
                                    <strong>Text Box B</strong>: Describe the kind(s) of exploitation that the Contributor will earn royalties from. <br/>
                                    Examples: ”all exploitations of the Work(s).” “sales of the works” “synch license fees from the Work(s)”, etc.
                                </p> */}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/ContractBlock/Consideration.jsx